import React from 'react';
import { useTheme } from '../../context/ThemeContext'
import './Footer.css';
import { scrollTo } from '../../utils/lenis';
import FooterLogo from '../../assets/Vertical_Logo_Turkish_Blue_.png';

const Footer = () => {
  const { theme, toggleTheme } = useTheme()

  const scrollToTop = () => {
    scrollTo(0);
  };

  return (
    <>
      <footer className="footer-container" id="contact-us">
        <div className="footer-glow" />
        <div className="footer-content">
          <div className="footer-top">
            <div className="footer-left">
              <div className="footer-logo">
                <img src={FooterLogo} alt="Jovexa Logo" height="28" style={{ objectFit: 'contain' }} />
                <h2 className="footer-brand-name">Jovexa</h2>
              </div>
              <p className="footer-subscribe-text">Get in touch with us</p>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <span>info@jovexa.in</span>
                </div>
                <div className="footer-contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <span>+91 62822 01702</span>
                </div>
                <div className="footer-contact-item">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span>St.Joseph’s College of Engineering and Technology,Palai,
                    Choondacherry P.O,
                    Palai, Kottayam 686 579,
                    Kerala,India.</span>
                </div>
              </div>
            </div>

            <div className="footer-right">
              <div className="footer-link-group">
                <h3>Navigation</h3>
                <a href="#home">Home</a>
                <a href="#featured">Featured</a>
                <a href="#our-team">Our Team</a>
              </div>
              <div className="footer-link-group">
                <h3>Legal</h3>
                <a href="/privacy">Privacy Policy</a>
                <a href="/terms">Terms of Service</a>
              </div>
              <div className="footer-link-group">
                <h3>Social</h3>
                <a href="https://linkedin.com">LinkedIn</a>
                <a href="https://instagram.com">Instagram</a>
                <a href="https://twitter.com">Twitter</a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 Jovexa Softlabs. All rights reserved.</p>
            <div className="footer-bottom-actions">
              <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
                {theme === 'dark' ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="5" />
                    <line x1="12" y1="1" x2="12" y2="3" />
                    <line x1="12" y1="21" x2="12" y2="23" />
                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                    <line x1="1" y1="12" x2="3" y2="12" />
                    <line x1="21" y1="12" x2="23" y2="12" />
                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                  </svg>
                )}
              </button>
              <button className="back-to-top" aria-label="Back to top" onClick={scrollToTop}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
